<template>
  <div
    :class="[pulseClasses, containerSizeClasses]"
    class="skeletons-PillSkeleton flex select-none items-center w-fit rounded-full border border-solid border-skeleton bg-whiteOverride"
    aria-hidden="true"
    data-test="container">
    <div
      :class="circleSizeClasses"
      class="bg-skeleton flex rounded-full items-center justify-center"
      data-test="circle">
    </div>
    <div
      :class="textSizeClasses"
      class="font-normal whitespace-nowrap"
      data-test="text">
      <span
        v-html="spaceChars"
        :class="textboxSizeClasses"
        class="whitespace-nowrap bg-skeleton"
        aria-hidden="true"
        data-test="characters">
      </span>
    </div>
  </div>
</template>

<script>
const sizes = [
  'normal',
  'large',
];

export default {
  name: 'SkeletonPill',
  props: {
    size: {
      type: String,
      required: false,
      default: 'normal',
      validator(value) {
        return sizes.includes(value);
      },
    },
    /**
     * When pulse is true and used within another skeleton
     * component, the pulsing increases.
     *
     * If this component is used on its own somewhere, it won't
     * pulse unless this is true.
     */
    pulse: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Number of character spaces to put in as a placeholder.
     * Basically it allows us width without needing to specify
     * a width. It can be randomised.
     *
     * Default is a random number between 15 and 25.
     */
    characters: {
      type: Number,
      required: false,
      default: () => Math.floor(Math.random() * 10) + 15,
    },
  },
  computed: {
    containerSizeClasses() {
      return {
        normal: 'size-normal p-{5px}',
        large: 'size-large p-{8px}',
      }[this.size];
    },
    circleSizeClasses() {
      return {
        normal: 'w-base h-base',
        large: 'w-{25px} h-{25px}',
      }[this.size];
    },
    textSizeClasses() {
      return {
        normal: 'px-xs',
        large: 'pl-sm pr-xs',
      }[this.size];
    },
    textboxSizeClasses() {
      return {
        normal: 'h-base rounded-md',
        large: 'h-twenty rounded-lg',
      }[this.size];
    },
    pulseClasses() {
      return {
        'animate-pulse': this.pulse,
      };
    },
    spaceChars() {
      return '&nbsp;'.repeat(this.characters);
    },
  },
};
</script>
